import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Options } from '@angular-slider/ngx-slider';
import { TerminalsApiService } from '../../../services/terminals-api.service';
import { environment } from '../../../../environments/environment';
import { Filter } from '../../../models/filter.model';
import { CodesApiService } from '../../../services/codes-api.service';
import { FILTER_NO_CERTIFICATE } from '../filter.constants';

export interface WareHouse {
  name: string;
  code: string;
}
@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss']
})
export class FilterDialogComponent implements OnInit, Filter {

  // showLanded = true;
  showNotLanded = false;
  showSingleLength = false;
  chooseWarehouse = false;
  selectedWarehouse = '';
  selectedWarehouseName = '';
  certificate?: string;
  minLength = 0;
  maxLength = 600;

  FILTER_NO_CERTIFICATE = FILTER_NO_CERTIFICATE;

  refreshLengthSlider: EventEmitter<void> = new EventEmitter<void>();
  lengthSliderOptions: Options = {
    stepsArray: environment.packetLengths.map(length => ({ value: length })),
    showTicks: true,
    animate: false,
    pushRange: false,
    draggableRange: false,
    enforceRange: true
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public input: Filter,
    private dialogRef: MatDialogRef<FilterDialogComponent>,
    public codesApiService: CodesApiService,
    public terminalsApiService: TerminalsApiService,
  ) { }

  ngOnInit() {
    Object.assign(this, this.input);
  }

  reset() {
    // this.showLanded = true;
    this.showNotLanded = false;
    this.showSingleLength = false;
    this.certificate = undefined;
    this.minLength = environment.packetLengths[0];
    this.maxLength = environment.packetLengths[environment.packetLengths.length - 1];
  }
  setWarehouse(name: string, code: string) {
    this.selectedWarehouse = code;
    this.selectedWarehouseName = name;
  }

  getFilter() {
    return {
      // showLanded: this.showLanded,
      showNotLanded: this.showNotLanded,
      showSingleLength: this.showSingleLength,
      certificate: this.certificate,
      warehouse: this.selectedWarehouse,
      minLength: this.minLength,
      maxLength: this.maxLength,
    };
  }

  close(): void {
    this.dialogRef.close(this.getFilter());
  }
}
